var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9973 13.0291V10.9453",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9968 14.7018C12.9199 14.7018 12.8575 14.7642 12.858 14.8411C12.858 14.918 12.9204 14.9804 12.9973 14.9804C13.0742 14.9804 13.1366 14.918 13.1366 14.8411C13.1366 14.7642 13.0742 14.7018 12.9968 14.7018",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1318 8.02367L18.3991 15.492C18.895 16.3601 18.2682 17.4404 17.2686 17.4404H8.73389C7.73377 17.4404 7.10695 16.3601 7.60339 15.492L11.8708 8.02367C12.3706 7.14836 13.632 7.14836 14.1318 8.02367Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarningTriangle);
export default __webpack_public_path__ + "static/media/ic_warning_triangle.5f93f82cf3338de92ed6aa8bd6005972.svg";
export { ForwardRef as ReactComponent };